"use client";

import React, { useEffect, useState } from "react";
import "./AnimCursor.scss";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  useEffect(() => {
    if (isMobile) return;

    const move = (e) => setPosition({ x: e.clientX, y: e.clientY });
    const addHover = () => setIsHovered(true);
    const removeHover = () => setIsHovered(false);

    window.addEventListener("mousemove", move);

    const hoverElements = document.querySelectorAll(
      "a, button, .cursor-hover, .card, .clickable, .hover-target"
    );

    hoverElements.forEach((el) => {
      el.addEventListener("mouseenter", addHover);
      el.addEventListener("mouseleave", removeHover);
    });

    return () => {
      window.removeEventListener("mousemove", move);
      hoverElements.forEach((el) => {
        el.removeEventListener("mouseenter", addHover);
        el.removeEventListener("mouseleave", removeHover);
      });
    };
  }, [isMobile]);

  if (isMobile) return null;

  return (
    <>
      <div
        className="custom-cursor-inner"
        style={{ left: position.x, top: position.y }}
      />
      <div
        className={`custom-cursor-outer ${isHovered ? "hovered" : ""}`}
        style={{ left: position.x, top: position.y }}
      />
    </>
  );
};

export default CustomCursor;
